import { Label } from "@/components/ui/label";

interface ResolutionSelectionProps {
  currentPackage: any;
  selectedResolution: string;
  setSelectedResolution: (value: string) => void;
}

export const ResolutionSelection = ({
  currentPackage,
  selectedResolution,
  setSelectedResolution
}: ResolutionSelectionProps) => {
  if (!currentPackage || !currentPackage.resolutionUpgrades) return null;

  return (
    <div>
      <Label htmlFor="resolution">Resolution Upgrade (Optional)</Label>
      <select
        id="resolution"
        value={selectedResolution}
        onChange={(e) => setSelectedResolution(e.target.value)}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-navy-500"
      >
        <option value="">Base Resolution ({currentPackage.baseResolution})</option>
        {currentPackage.resolutionUpgrades.map((upgrade: any) => (
          <option key={upgrade.resolution} value={upgrade.resolution}>
            Upgrade to {upgrade.resolution} (+${upgrade.price})
          </option>
        ))}
      </select>
    </div>
  );
};